import Page from './Page';
import stage from './Stage';
import globals from './Globals';
import RenderContainer from './RenderContainer';
import PlayButton from './PlayButton';
import ReadButton from './ReadButton';
import Swiper from './Swiper';
import SoundManager from '../ts/SoundManager.ts';

// Container for pages in a book
class Book extends RenderContainer {
  constructor(ebookModel) {
    super();
    this.ebookModel = ebookModel;
    this.pages = {};
    this.bookLength = this.ebookModel.pages.length + 1;
    this.name = 'Book';
    this.setBounds(0, 0, globals.width * this.bookLength, globals.height);
    for (let index = 0; index < this.bookLength; index += 1) {
      this.pages[index] = new Page(index, this.ebookModel);
      this.addChildAt(this.pages[index], 0);
      this.pages[index].visible = true;
    }

    this.currentPage = this.pages['0'];
    this.currentPage.visible = true;

    const playButton = new PlayButton();
    const readButton = new ReadButton();
    this.pages[0].addChildAt(playButton, 0);
    this.pages[0].addChildAt(readButton, 0);

    this.on(
      'pressmove',
      () => {
        this.render.stream = true;
      },
      this
    );
    const locations = [];

    this.pages.forEach(page => {
      locations.push(page.offset);
    });

    // Creates a swiper, installs a callback to update itself once swiper is complete
    this.swiper = new Swiper(
      stage,
      this,
      locations,
      (() => {
        if (this.hasPageTurned()) {
          this.homeTextPositions();
          const newPage = this.getSwiperPage();
          this.changePage(newPage);

          SoundManager.stop();
          if (this.ebookModel.pageHasNarration(this.currentPage.index)) {
            SoundManager.playSound(this.currentPage.narrationName);
          }
        }

        if (!this.isCurrentPageHome() && this.isAuto) {
          this.createPageTurnTimer();
        }
        this.swiper.mouseEnabled = this.isCurrentPageHome()
          ? false
          : !this.isAuto;

        this.render.once = true;
        this.render.stream = false;
      })
    );

    this.swiper.mouseEnabled = false;
    // Adds pages to hiding logic so that we're not drawing all pages at once
    this.swiper.attachHideables(this.pages);

    // Attach a white image below pages so that touches are registered everywhere.
    this.backplane = new createjs.Shape();
    this.backplane.graphics
      .beginFill('#ffffff')
      .drawRect(
        this.x,
        this.y,
        this.getBounds().width,
        this.getBounds().height
      );
    this.addChildAt(this.backplane, 0);

    this.isAuto = false;
    this.render.stream = false;
    this.render.once = true;

    stage.on('nextPage', this.swipeToNextPage.bind(this));
    stage.on('previousPage', this.swipeToPreviousPage.bind(this));
  }


  // to hack in moving pages with button presses
  // instead of swiping, I manipulate the internal
  // state of the swiper responsible for 
  // the changing of pages. this is bad, and I
  // shouldn't do it, but I don't have time to do
  // it properly.
  swipeToNextPage() {
    this.currentPage = this.pages[this.currentPage.index + 1];
    SoundManager.stop();
    if (this.ebookModel.pageHasNarration(this.currentPage.index)) {
      SoundManager.playSound(this.currentPage.narrationName);
    }

    // pretend we have been dragging
    this.swiper.currentPos = this.swiper.positions[this.currentPage.index];
    this.swiper.dragDistance += 1
    this.swiper.checkPosTransitions()

    if (this.currentPage.textFrame.locations.length === 1 
        || this.currentPage.textFrame.locations.length === 0) {
      this.dispatchEvent('HideTextButtons', true);
    } else {
      this.dispatchEvent('ShowTextButtons', true);
    }
    
    this.render.stream = true;
  }

  swipeToPreviousPage() {
    this.currentPage = this.pages[this.currentPage.index - 1];
    SoundManager.stop();
    if (this.ebookModel.pageHasNarration(this.currentPage.index)) {
      SoundManager.playSound(this.currentPage.narrationName);
    }

    // pretend we have been dragging
    this.swiper.currentPos = this.swiper.positions[this.currentPage.index];
    this.swiper.dragDistance -= 1
    this.swiper.checkPosTransitions()

    if (this.currentPage.textFrame.locations.length === 1 
        || this.currentPage.textFrame.locations.length === 0) {
      this.dispatchEvent('HideTextButtons', true);
    } else {
      this.dispatchEvent('ShowTextButtons', true);
    }
    
    this.render.stream = true;
  }

  changePage(page) {
    this.currentPage = page;
    if (this.isCurrentPageHome()) {
      this.dispatchEvent('HomePage', true);
      this.swiper.mouseEnabled = false;
    }
  }

  createPageTurnTimer() {
    this.pageTurnTimer = window.setTimeout(
      () => {
        this.render.stream = true;
        this.swiper.slideToNextPos();
        console.info(this.currentPage.getSoundDuration());
      },
      this.currentPage.getSoundDuration() * 1000, // in milli seconds
      this
    );
  }

  getSwiperPage() {
    return this.pages[String(this.swiper.currentPos.index)];
  }

  isCurrentPageHome() {
    return this.currentPage.index === 0;
  }

  // Checks whether the swiper page is the same as the books internal page
  hasPageTurned() {
    return this.currentPage.index !== this.getSwiperPage().index;
  }

  read(bool) {
    if (bool) {
      this.pages.forEach((page, i) => {
        if (i > 0) { page.moveDownNextPrevTextBtns() }
      })
      this.isAuto = false;
      this.render.stream = true;
      this.swiper.slideToNextPos();
    }
  }

  autoPlay(bool) {
    this.isAuto = bool;
    if (bool) {
      this.pages.forEach((page, i) => {
        if (i > 0) { page.moveUpNextPrevTextBtns() }
      })
      this.render.stream = true;
      this.swiper.slideToNextPos();
    }
  }

  // Resets the position of the texts on all the textFrames per page
  homeTextPositions() {
    this.pages.forEach(page => {
      page.homeText();
    });
  }

  home() {
    this.isAuto = false;
    clearInterval(this.pageTurnTimer);
    this.render.stream = true;
    this.swiper.home();
  }
}

export { Book as default };
